export enum UploadActionTypes {
  IMPORT = "IMPORT",
  UPLOAD = "UPLOAD",
}

export const FileConfig = {
  maxSize: 5,
  formats: ".json, .zip",
};
// do not allow to change the import file config from outside
Object.freeze(FileConfig);
